import type { SVGProps } from "react";

export const GoogleJobs = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="find-jobs"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Google jobs</title>
    <path
      d="m341.732 370.61 28.885-28.886 35.547 35.546-28.886 28.885z"
      fill="#676e87"
    />
    <path
      d="m370.61 341.73-7.5 7.5 13.64 13.64a20.38 20.38 0 0 1 0 28.82l-7 7 7.5 7.5 28.88-28.88Z"
      fill="#595f74"
    />
    <path
      d="M493.92 493.92a36.13 36.13 0 0 1-51.1 0l-65.54-65.54a15.7 15.7 0 0 1 0-22.22l28.88-28.88a15.7 15.7 0 0 1 22.22 0l65.54 65.54a36.13 36.13 0 0 1 0 51.1Z"
      fill="#ffcd85"
    />
    <path
      d="m493.92 442.82-65.54-65.54a15.7 15.7 0 0 0-22.22 0l-3.89 3.89 61.65 61.65a36.13 36.13 0 0 1 0 51.1 36.15 36.15 0 0 1-10.55 7.32 36.15 36.15 0 0 0 40.55-7.32 36.13 36.13 0 0 0 0-51.1Z"
      fill="#ffc166"
    />
    <circle
      cx="214.59"
      cy="214.59"
      fill="#b3e0ff"
      r="207.19"
      transform="rotate(-45 214.588 214.595)"
    />
    <circle cx="214.59" cy="214.59" fill="#d9f0ff" r="166.73" />
    <rect
      fill="#ffc166"
      height="124.82"
      rx="12.31"
      width="187.61"
      x="120.79"
      y="168.5"
    />
    <path
      d="M296.08 168.5h-30a12.32 12.32 0 0 1 12.32 12.31V281a12.32 12.32 0 0 1-12.32 12.31h30A12.32 12.32 0 0 0 308.4 281V180.81a12.32 12.32 0 0 0-12.32-12.31Z"
      fill="#ffb74e"
    />
    <path
      d="m308.4 206-85.66 37.29a20.44 20.44 0 0 1-16.3 0L120.79 206v-25.19a12.31 12.31 0 0 1 12.31-12.31h163a12.32 12.32 0 0 1 12.32 12.31Z"
      fill="#ffae36"
    />
    <path
      d="M296.08 168.5h-30a12.32 12.32 0 0 1 12.32 12.31V219l30-13.06v-25.13a12.32 12.32 0 0 0-12.32-12.31Z"
      fill="#ffa41f"
    />
    <rect fill="#676e87" height="30" rx="7" width="30" x="199.59" y="227.05" />
    <path
      d="M222.59 227.05h-11.48a7 7 0 0 1 7 7v16a7 7 0 0 1-7 7h11.48a7 7 0 0 0 7-7v-16a7 7 0 0 0-7-7Z"
      fill="#595f74"
    />
    <path
      d="M499.22 437.51 433.68 372a23.19 23.19 0 0 0-26.63-4.41l-22.18-22.18A214.71 214.71 0 0 0 62.78 62.78a214.72 214.72 0 0 0 282.6 322.09l22.18 22.18a23.19 23.19 0 0 0 4.44 26.63l65.54 65.54a43.64 43.64 0 0 0 61.71-61.71ZM341.29 369l-.2.18A199.71 199.71 0 0 1 73.39 73.39a199.71 199.71 0 0 1 295.76 267.67l-.22.26q-6.18 7.5-13.14 14.47T341.29 369Zm15.71 6.26c3.21-2.86 6.36-5.8 9.42-8.86s6-6.21 8.86-9.42l20.29 20.3-18.27 18.27Zm131.61 113.35a28.65 28.65 0 0 1-40.49 0l-65.54-65.54a8.22 8.22 0 0 1 0-11.61l28.88-28.88a8.22 8.22 0 0 1 11.61 0l65.54 65.54a28.65 28.65 0 0 1 0 40.49ZM296.08 161h-31v-11.53A21.13 21.13 0 0 0 244 128.36h-58.8a21.13 21.13 0 0 0-21.11 21.11V161h-31a19.82 19.82 0 0 0-19.81 19.81V281a19.83 19.83 0 0 0 19.81 19.82h163A19.84 19.84 0 0 0 315.9 281V180.81A19.83 19.83 0 0 0 296.08 161Zm-117-11.53a6.12 6.12 0 0 1 6.11-6.11H244a6.12 6.12 0 0 1 6.11 6.11V161h-71ZM300.9 281a4.82 4.82 0 0 1-4.82 4.82h-163a4.82 4.82 0 0 1-4.81-4.82v-63.6l63.8 27.77v4.88a14.52 14.52 0 0 0 14.5 14.5h16a14.52 14.52 0 0 0 14.5-14.5v-4.88l63.83-27.77Zm-93.81-31.45v-15h15v15ZM300.9 201l-64.67 28.14a14.5 14.5 0 0 0-13.64-9.63h-16a14.52 14.52 0 0 0-13.59 9.67L128.29 201v-20.19a4.82 4.82 0 0 1 4.81-4.81h163a4.82 4.82 0 0 1 4.82 4.81Zm36.89-109.61c-67.93-67.93-178.47-67.93-246.4 0a174.23 174.23 0 0 0 246.4 246.4 174.23 174.23 0 0 0 0-246.4Zm-10.6 235.8a159.25 159.25 0 1 1 46.63-112.6 158.76 158.76 0 0 1-46.63 112.6Z"
      fill="#272a33"
    />
  </svg>
);

export default GoogleJobs;
